export default "__VITE_ASSET__DxITjOC6__";